import React, { Component } from "react";
import "../../Styles/TenanatDashBoard.scss";
import BarChartContainer from "./BarChart";
import BurnDownChartContainer from "./BurnDownChart";
import HeatMapChartContainer from "./HeatMapChart";
import HeatMapTimeStamp from "./HeatMapTimeStamp";
import LineChartContainer from "./LineChart";
import PieChartContainer from "./PieChart";
import Histogramwidget from "./HistogramWidget";
import RichTextChart from "./RichTextChart";
import TileChart from "./TileChart";
import DataReportForRisk from "./DataReportForRisk";
import DataReportForAction from "./DataReportForAction";
import TrendingLineChart from "./TrendingLineChart";

const getBaseItemStyle = (isActive) => ({
  fontSize: "16px",
  textAlign: "center",
  outline: "none",
  cursor: "move",
  display: "inline-block",
  
});
const classNames = ["col-xs-12 col-sm-12 col-md-6"];
export default class SortableWidgetUI extends Component {
  
  constructor(props) {
    super(props);
    this.state = {};
    if (this.props.isDisabled) {
      classNames.push("k-state-disabled");
    }
  }

  changeLineChartWidth = (widgetId) => {
    this.props.onSetWidgetId(widgetId);
  };

  refreshTextWidget=(htmlData,widgetId,editable)=>{
    this.props.refreshTextWidget(htmlData,widgetId,editable);
  }

  refreshTextNarative=(text,widgetId)=>{
    this.props.refreshTextNarative(text,widgetId);
  }

  handleWidgetFullView = (expandWidgetId, widget) => {
    let widgetView = expandWidgetId.filter((item) => item === widget);
    if (widgetView.length > 0) {
      return true;
    } else {
      return false;
    }
  };
  render() {
    const {
      isActive,
      style,
      attributes,
      dataItem,
      forwardRef,
    } = this.props;
    return (
      <div
        ref={forwardRef}
        {...attributes}
        style={{
          ...getBaseItemStyle(isActive),
          ...style,
        }}
        // className={classNames.join(' ')}
        className={
          this.handleWidgetFullView(
            this.props.expandWidgetId,
            dataItem.widgetId
          )
            ? "fullWidth wBox"
            : "wBox"
        }
      >
        <div className="wGrid">
          <div className="wGBox">
            {/* <div className="expandView">
                      <a className="expand" onClick={() => changeLineChartWidth(dataItem.widgetId)} >
                          <img src={Images.VIEWFULLVIEW} alt="Expand" width="10"/>
                        </a>
                        <a className="shrink" onClick={() => changeLineChartWidth(dataItem.widgetId)} >
                          <img src={Images.SHRINK} alt="Expand" width="10"/>
                        </a>
                      </div> */}
            <div className="wgHeader">
              <h4
                title={
                  dataItem.description
                    ? dataItem.description
                    : "Description not available"
                }
              >
                {dataItem.widgetName}
              </h4>
            </div>
            {/* <div className="wgHeader">
                <h5 class="wgTitle">{dataItem.title ? dataItem.title : ""}</h5>
              </div> */}
            <div className="chartCont">
              {dataItem.widgetType == "LINE_CHART" ? (
                <LineChartContainer
                  chartInputs={dataItem}
                  changeLineChartWidth={this.changeLineChartWidth}
                  flag={true}
                  selectedDB={this.props.selectedDB}
                  expandIcon={true}
                  selectedDashboard={this.props.selectedDashboard}
                  isFreezeDS={this.props.isFreezeDS}
                  isTenentAdmin={this.props.isTenentAdmin}
                  refreshTextNarative={this.refreshTextNarative}
                />
              ) : (
                ""
              )}
               {dataItem.widgetType == "TRENDING_CHART" ? (
                <TrendingLineChart
                  chartInputs={dataItem}
                  changeLineChartWidth={this.changeLineChartWidth}
                  flag={true}
                  selectedDB={this.props.selectedDB}
                  expandIcon={true}
                  selectedDashboard={this.props.selectedDashboard}
                  isFreezeDS={this.props.isFreezeDS}
                  isTenentAdmin={this.props.isTenentAdmin}
                  refreshTextNarative={this.refreshTextNarative}
                />
              ) : (
                ""
              )}
              {dataItem.widgetType == "BURN_DOWN_CHART" ? (
                <BurnDownChartContainer
                  chartInputs={dataItem}
                  changeLineChartWidth={this.changeLineChartWidth}
                  flag={true}
                  selectedDB={this.props.selectedDB}
                  expandIcon={true}
                  selectedDashboard={this.props.selectedDashboard}
                  isFreezeDS={this.props.isFreezeDS}
                  isTenentAdmin={this.props.isTenentAdmin}
                  refreshTextNarative={this.refreshTextNarative}
                />
              ) : (
                ""
              )}
              {dataItem.widgetType == "BAR_CHART" ? (
                <BarChartContainer
                  chartInputs={dataItem}
                  changeLineChartWidth={this.changeLineChartWidth}
                  flag={true}
                  selectedDB={this.props.selectedDB}
                  expandIcon={true}
                  selectedDashboard={this.props.selectedDashboard}
                  isFreezeDS={this.props.isFreezeDS}
                  isTenentAdmin={this.props.isTenentAdmin}
                  refreshTextNarative={this.refreshTextNarative}
                />
              ) : (
                ""
              )}
              {dataItem.widgetType == "TEXT_WIDGET" ? (
                <RichTextChart
                  chartInputs={dataItem}
                  changeLineChartWidth={this.changeLineChartWidth}
                  refreshTextWidget={this.refreshTextWidget}
                  flag={true}
                  selectedDB={this.props.selectedDB}
                  expandIcon={true}
                  selectedDashboard={this.props.selectedDashboard}
                  isFreezeDS={this.props.isFreezeDS}
                  isTenentAdmin={this.props.isTenentAdmin}
                  refreshTextNarative={this.refreshTextNarative}
                />
              ) : (
                ""
              )}
              {dataItem.widgetType == "DATA" && !dataItem.isActionWidget ? (
                <DataReportForRisk
                  chartInputs={dataItem}
                  changeLineChartWidth={this.changeLineChartWidth}
                  refreshTextWidget={this.refreshTextWidget}
                  flag={true}
                  selectedDB={this.props.selectedDB}
                  expandIcon={true}
                  selectedDashboard={this.props.selectedDashboard}
                  isFreezeDS={this.props.isFreezeDS}
                  isTenentAdmin={this.props.isTenentAdmin}
                  customFieldsmaster={this.props.customFieldsmaster}
                  HeatMapConfigDataOpportunity={this.props.HeatMapConfigDataOpportunity}
                  HeatMapConfigDataThreat={this.props.HeatMapConfigDataThreat}
                  dynamicHeatmapProbabilityRange={this.props.dynamicHeatmapProbabilityRange}
                  refreshTextNarative={this.refreshTextNarative}
                />
              ) : (
                ""
              )}
              {dataItem.widgetType == "DATA" && dataItem.isActionWidget ? (
                <DataReportForAction
                  chartInputs={dataItem}
                  changeLineChartWidth={this.changeLineChartWidth}
                  refreshTextWidget={this.refreshTextWidget}
                  flag={true}
                  selectedDB={this.props.selectedDB}
                  expandIcon={true}
                  selectedDashboard={this.props.selectedDashboard}
                  isFreezeDS={this.props.isFreezeDS}
                  isTenentAdmin={this.props.isTenentAdmin}
                  customFieldsmaster={this.props.customFieldsmaster}
                  refreshTextNarative={this.refreshTextNarative}
                />
              ) : (
                ""
              )}
              {dataItem.widgetType == "KPI" ? (
                <TileChart
                  chartInputs={dataItem}
                  changeLineChartWidth={this.changeLineChartWidth}
                  refreshTextWidget={this.refreshTextWidget}
                  flag={true}
                  selectedDB={this.props.selectedDB}
                  expandIcon={true}
                  selectedDashboard={this.props.selectedDashboard}
                  isFreezeDS={this.props.isFreezeDS}
                  isTenentAdmin={this.props.isTenentAdmin}
                  refreshTextNarative={this.refreshTextNarative}
                />
              ) : (
                ""
              )}
              {dataItem.widgetType === "DOUGHNUT_CHART" ? (
                <Histogramwidget
                  chartInputs={dataItem}
                  changeLineChartWidth={this.changeLineChartWidth}
                  flag={true}
                  selectedDB={this.props.selectedDB}
                  expandIcon={true}
                  selectedDashboard={this.props.selectedDashboard}
                  isFreezeDS={this.props.isFreezeDS}
                  isTenentAdmin={this.props.isTenentAdmin}
                  refreshTextNarative={this.refreshTextNarative}
                />
              ) : (
                ""
              )}
              {dataItem.widgetType == "PIE_CHART" ? (
                <PieChartContainer
                  chartInputs={dataItem}
                  changeLineChartWidth={this.changeLineChartWidth}
                  flag={true}
                  selectedDB={this.props.selectedDB}
                  expandIcon={true}
                  selectedDashboard={this.props.selectedDashboard}
                  isFreezeDS={this.props.isFreezeDS}
                  isTenentAdmin={this.props.isTenentAdmin}
                  refreshTextNarative={this.refreshTextNarative}
                />
              ) : (
                ""
              )}

              {dataItem.widgetType == "HEAT_MAP" &&
              dataItem.timeStamp == false ? (
                <HeatMapChartContainer
                  chartInputs={dataItem}
                  changeLineChartWidth={this.changeLineChartWidth}
                  flag={true}
                  selectedDB={this.props.selectedDB}
                  expandIcon={true}
                  selectedDashboard={this.props.selectedDashboard}
                  isFreezeDS={this.props.isFreezeDS}
                  showTableFromDashboard={this.props.showTableFromDashboard}
                  isTenentAdmin={this.props.isTenentAdmin}
                  refreshTextNarative={this.refreshTextNarative}
                />
              ) : (
                ""
              )}

              {dataItem.widgetType == "HEAT_MAP" &&
              dataItem.timeStamp == true ? (
                <HeatMapTimeStamp
                  chartInputs={dataItem}
                  changeLineChartWidth={this.changeLineChartWidth}
                  flag={true}
                  selectedDB={this.props.selectedDB}
                  expandIcon={true}
                  selectedDashboard={this.props.selectedDashboard}
                  isFreezeDS={this.props.isFreezeDS}
                  showTableFromDashboard={this.props.showTableFromDashboard}
                  isTenentAdmin={this.props.isTenentAdmin}
                  refreshTextNarative={this.refreshTextNarative}
                />
              ) : (
                ""
              )}
            </div>
            {/* <div className="wgHeader">
                <h4>Dataset: {dataItem.dataSource} </h4>
              </div> */}
          </div>
        </div>
      </div>
    );
  }
}
